import * as ActionConfigurationManager from './config.actions';
import { Action } from 'rxjs/internal/scheduler/Action';

export const invalidCode = ActionConfigurationManager.CODE_INVALID
export const resetInvalidCodeState = ActionConfigurationManager.RESET_INVALID_CODE_STATE
export const validCode = ActionConfigurationManager.CODE_VALID
